import splitUrlPiece from './splitUrlPiece';

/**
 * Splits a URL in half by querystring '?'
 */
const splitUrl = splitUrlPiece.bind(null, '?');

export default splitUrl;
